import { useState, SyntheticEvent, useEffect } from 'react';
import { RootState } from 'src/store/reducers';
import { getLabelFallback, getSimplePrescriptionValuesArray } from '@utils/utils';
import PageLayout from '@components/PageLayout';
import { FormTable, PrismForm } from '@components/my-prescriptions/FormTable';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from '@mui/material';

import ArrowLeft from '@images/svg-icons/arrowLeft.svg';
import EyeWear from '@images/svg-icons/eyewearWhite.svg';
import ContactLenses from '@images/svg-icons/contactLensesWhite.svg';

import { useNavigate } from 'react-router-dom';

type Props = {};
import * as actions from '@redux-actions/';

//class FullPrescriptionForm extends React.Component {
const AddPrescriptionDefault = (props: Props): JSX.Element => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const config = useSelector((state: RootState) => state.common.config);
    const isMobile = useSelector((state: RootState) => state.common.isMobile);

    const addPrescriptionsDefaultBackLabel = getLabelFallback(
        'MYPROFILE_MY_PRESCRIPTIONS_BACK_TO_PRESCRIPTIONS_MOBILE'
    );
    const addPrescriptionsDefaultTitleLabel = getLabelFallback(
        'MYPROFILE_MY_PRESCRIPTIONS_ADD_PRESCRIPTION_TITLE'
    );

    return (
        <PageLayout
            hideMenu
            labelMenu={addPrescriptionsDefaultTitleLabel}
            backLabel={addPrescriptionsDefaultBackLabel}
        >
            <div className="add-prescription-default">
                <div className="header-container">
                    <div className="backDiv mobile-hide">
                        <button
                            role="region"
                            aria-label="back button"
                            className="back-button"
                            data-element-id="MyPrescription_Back"
                            onClick={() => navigate(config.pagesUrl.myAppointments.myPrescriptions)}
                        >
                            <div>
                                <span className="start-icon">
                                    <ArrowLeft />
                                </span>
                                <span>
                                    {getLabelFallback(
                                        'MYPROFILE_MY_PRESCRIPTIONS_BACK_TO_PRESCRIPTIONS'
                                    )}
                                </span>
                            </div>
                        </button>
                        <div
                            role="region"
                            aria-label="my prescriptions page title"
                            className="primary-title"
                        >
                            <span>
                                {getLabelFallback(
                                    'MYPROFILE_MY_PRESCRIPTIONS_ADD_PRESCRIPTION_TITLE'
                                )}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="add-prescription-default-container" role="form">
                    <div className="add-prescription-default-container-title">
                        {getLabelFallback(
                            'MYPROFILE_MY_PRESCRIPTIONS_ADD_PRESCRIPTIONS_DEAFAULT_CONTAINER'
                        )}
                    </div>
                    <div className="add-prescription-default-container-button">
                        <div className="add-prescription-default-container-button-contacts">
                            <button
                                className="primary-button button-size-medium black"
                                data-analytics_available_call="0"
                                onClick={() =>
                                    navigate(config.pagesUrl.myAppointments.addPrescriptionContact)
                                }
                                data-element-id="MyPrescriptions_AddCL"
                            >
                                <ContactLenses />
                                {getLabelFallback(
                                    'MYPROFILE_MY_PRESCRIPTIONS_CL_PRESCRIPTION_DEFAULT'
                                )}
                            </button>
                        </div>
                        <div className="add-prescription-default-container-button-glasses add-prescription">
                            <button
                                className="primary-button button-size-medium black"
                                data-analytics_available_call="0"
                                onClick={() =>
                                    navigate(config.pagesUrl.myAppointments.addPrescriptionForm)
                                }
                                data-element-id="MyPrescriptions_AddEyewear"
                            >
                                <EyeWear />
                                {getLabelFallback(
                                    'MYPROFILE_MY_PRESCRIPTIONS_EYEWEAR_PRESCRIPTION_DEFAULT'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </PageLayout>
    );
};

export default AddPrescriptionDefault;
